// Barème taxe d'achat (Mas Rechisha) — Non-résidents 2024
export const purchaseTaxBrackets = [
  { upTo: 5600000, rate: 0.08 },
  { upTo: Infinity, rate: 0.10 },
];

// Arnona estimations annuelles par m² par ville
export const arnonaRates = {
  'tel-aviv': 150,
  'jerusalem': 115,
  'haifa': 90,
  'netanya': 80,
  'beer-sheva': 65,
  'ashdod': 70,
  'eilat': 75,
};

// Frais annexes indicatifs
export const purchaseCosts = {
  lawyerPercent: 1.25,       // % du prix d'achat
  agencyPercent: 2.0,        // % du prix d'achat (acheteur)
  registrationFlatFee: 5000, // ₪ frais d'enregistrement Tabu
};

// Impôt sur revenus locatifs
export const rentalTaxOptions = [
  { label: 'Forfaitaire 15 %', rate: 0.15, description: 'Sur loyer brut, sans déduction de charges. Simple et souvent avantageux pour les petits revenus.' },
  { label: 'Régime réel', rate: null, description: "Déduction des charges réelles. Taux marginal d'imposition (jusqu'à 50 %). Intéressant si charges élevées." },
];

export function calcPurchaseTax(price) {
  let tax = 0;
  let prevLimit = 0;
  for (const bracket of purchaseTaxBrackets) {
    const limit = Math.min(bracket.upTo, price);
    if (limit <= prevLimit) break;
    tax += (limit - prevLimit) * bracket.rate;
    prevLimit = limit;
    if (limit >= price) break;
  }
  return tax;
}

export function calcTotalPurchaseCost(price) {
  const tax = calcPurchaseTax(price);
  const lawyer = price * (purchaseCosts.lawyerPercent / 100);
  const agency = price * (purchaseCosts.agencyPercent / 100);
  const registration = purchaseCosts.registrationFlatFee;
  return { tax, lawyer, agency, registration, total: tax + lawyer + agency + registration };
}
